export const GET_ROLES_FAILED_MESSAGE = "error:roles.get-roles-failed"
export const GET_ALL_ROLE_SETTINGS_FAILED_MESSAGE = "error:roles.get-all-role-settings-failed"
export const GET_ALL_GLOBAL_PERMISSIONS_FAILED_MESSAGE = "error:roles.get-all-global-permissions-failed"
export const CREATE_ROLE_FAILED_MESSAGE = "error:roles.create-role-failed"
export const UPDATE_ROLE_FAILED_MESSAGE = "error:roles.update-role-failed"
export const DELETE_ROLE_FAILED_MESSAGE = "error:roles.delete-role-failed"
